import { render } from "./SectionTechDataPlay.vue?vue&type=template&id=23c9760d&scoped=true"
import script from "./SectionTechDataPlay.vue?vue&type=script&lang=js"
export * from "./SectionTechDataPlay.vue?vue&type=script&lang=js"

import "./SectionTechDataPlay.vue?vue&type=style&index=0&id=23c9760d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c9760d"]])

export default __exports__